/**
 * Centralized WebSocket Token Manager
 * 
 * Provides a unified event system for token refresh across all WebSocket services.
 * This ensures all WebSocket connections are updated when tokens are refreshed.
 * 
 * @author System
 * @version 1.0.0
 */

// Simple event emitter for token refresh events
class TokenRefreshEmitter {
  constructor() {
    this.listeners = new Set();
  }

  /**
   * Subscribe to token refresh events
   * @param {Function} callback - Callback function that receives the new token
   * @returns {Function} Unsubscribe function
   */
  onTokenRefreshed(callback) {
    if (typeof callback !== 'function') {
      console.warn('[TokenRefreshEmitter] Callback must be a function');
      return () => {};
    }

    this.listeners.add(callback);

    // Return unsubscribe function
    return () => {
      this.listeners.delete(callback);
    };
  }

  /**
   * Emit token refresh event to all listeners
   * @param {string} newToken - The new access token
   */
  emitTokenRefreshed(newToken) {
    if (!newToken || newToken === 'null' || newToken === 'undefined' || newToken.trim() === '') {
      console.warn('[TokenRefreshEmitter] Invalid token provided');
      return;
    }

    this.listeners.forEach(callback => {
      try {
        callback(newToken);
      } catch (error) {
        console.error('[TokenRefreshEmitter] Error in token refresh callback:', error);
      }
    });
  }
}

// Singleton instance
const tokenRefreshEmitter = new TokenRefreshEmitter();

export default tokenRefreshEmitter;
